import { useState } from "react";

import { Grid, TextField } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField, IconAutocomplete } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";
import { INCIDENT_STATUS_OPTIONS } from "../../../../lib/ui/iconSelectOptions";
import { useTranslation } from "react-i18next";

const StatusIncidentBody = (item: any) => {
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState<string | null>(item?.status || null);

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.incident")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentId"
              name="incidentId"
              label={t("common.id")}
              variant="outlined"
              size="small"
              value={item?.id || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentTitle"
              name="incidentTitle"
              label={t("common.title")}
              variant="outlined"
              size="small"
              value={item?.title || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("common.status")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <IconAutocomplete
              options={INCIDENT_STATUS_OPTIONS}
              value={selectedStatus}
              onChange={setSelectedStatus}
              label={t("common.status")}
              noOptionsText="No status options found"
            />
            <FormHiddenField name="status" value={selectedStatus || ""} />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="resolution"
              name="resolution"
              label={t("incidents.resolution")}
              variant="outlined"
              size="small"
              multiline
              rows={3}
              placeholder={t("common.optional")}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default StatusIncidentBody;
